import { createClient } from '@supabase/supabase-js';
import { isVerboseLoggingEnabled, logger } from './logger';

// Jedyny punkt tworzenia klienta Supabase – pobiera konfigurację z Vite/env.
// Auth session jest utrzymywana lokalnie, bo konto jest opcjonalną warstwą produktu.
const metaEnv = typeof import.meta !== 'undefined'
  ? import.meta.env
  : undefined;

const IS_TEST = typeof process !== 'undefined' && process.env?.NODE_ENV === 'test';

const isValidHttpUrl = (value: string | undefined): value is string => {
  if (!value) return false;

  try {
    const parsed = new URL(value);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
};

const envSupabaseUrl = (metaEnv?.VITE_SUPABASE_URL || process.env?.VITE_SUPABASE_URL) as string | undefined;
const supabaseUrl = isValidHttpUrl(envSupabaseUrl)
  ? envSupabaseUrl
  : (IS_TEST ? 'http://localhost:54321' : envSupabaseUrl);
const supabaseAnon = (
  metaEnv?.VITE_SUPABASE_ANON_KEY ||
  process.env?.VITE_SUPABASE_ANON_KEY ||
  (IS_TEST ? 'test-anon-key' : undefined)
) as string | undefined;

if (!supabaseUrl || !supabaseAnon) {
  throw new Error('Supabase configuration missing');
}

if (!IS_TEST && isVerboseLoggingEnabled()) {
  logger.info('SUPABASE_INIT', {
    url: supabaseUrl,
  });
}

export const supabase = createClient(supabaseUrl, supabaseAnon, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
    flowType: 'pkce',
  },
});

if (!IS_TEST && isVerboseLoggingEnabled()) {
  logger.debug('SUPABASE_READY', { clientCreated: !!supabase });
}
